import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { RecordingRequestMetaSelector } from 'features/recording';
import Field from 'components/Field';
import styles from './RequestedLectureListModal.module.scss';

const RequestedLectureListModal = () => {
  const requestMeta = useSelector(RecordingRequestMetaSelector);
  const {
    instructor_name: instructorName,
    name: moduleName,
    lecture_names: lectureNames,
  } = requestMeta;

  return (
    <div className={styles.root}>
      <div className="bold h3 m-b-20 dark">Module Details</div>
      <hr />
      <div className="p-b-5 m-t-20">
        <span className={styles.detailsFeild}>Module Name:</span>
        {moduleName}
      </div>
      <div className="p-b-5 m-t-5 m-b-5">
        <span className={styles.detailsFeild}>Instructor:</span>
        {instructorName}
      </div>
      {lectureNames && (
        <Field
          name="lecture_list"
          label="Lecture List:"
          labelClassName={styles.detailsFeild}
        >
          <div className={classNames(styles.listcontainer, 'scroll')}>
            <ul>
              {lectureNames.map((lecture) => (
                <li
                  className="h6"
                  key={lecture}
                >
                  {lecture}
                </li>
              ))}
            </ul>
          </div>
        </Field>
      )}
      {!lectureNames && (
        <div className={styles.noLecturePresent}>
          <hr />
          No Lectures Present
        </div>
      )}
    </div>
  );
};

export default RequestedLectureListModal;
